<template>
    <div>
        <div class="modal-container has-text-centered" >
            <div class="">
                <!-- <button id="xButt" class="delete" @click="$emit('close')"></button> -->

                <img :src="message" @click="$emit('close')"/>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {message: String},
  methods: {
     
    
  }
}
</script>

<style lang="sass" scoped>

    .modal-container
        position: relative
        margin: 0px auto
        color: #fff
        border-bottom: 2px solid #f1c232
        border-top: 2px solid #f1c232
        transition: all .3s ease
        font-family: Helvetica, Arial, sans-serif
        max-width: 90vw
        max-height: 90vh
        background: black
        overflow: hidden
        overflow-y: auto
        padding: 10px
        
    

    #xButt
        background-color: #f1c232
        position: absolute
        font-size: 2rem !important
        right:10px
        top: 10px
        
    
    .delete::after
        width: 1px
        height: 100%
        background: black
    
    .delete::before
        height: 1px
        width: 100%
        background: black
    
   

</style>
